import React from "react";
import { Stack, Text } from "@chakra-ui/react";
import ReactDatePicker from "react-datepicker";
import { Required } from "./Required";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { LeftArrowIcon, RightArrowIcon } from "../../design_library";
import "./style.css";
export const DatePicker = (props: {
  label: string;
  value: string; // Date string in YYYY-MM-DD format
  field: string;
  required: boolean;
  error: string;
  onChange: (field: string, value: string) => void;
}) => {
  // Parse stored value as a UTC date-only string and construct a local Date
  // at local midnight for display. This ensures the same calendar day is
  // highlighted regardless of the user's timezone.
  const dateDefault = (() => {
    if (!props.value) return new Date();
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(props.value);
    if (!match) return new Date();
    const year = Number(match[1]);
    const monthIndex = Number(match[2]) - 1; // 0-based
    const day = Number(match[3]);
    return new Date(year, monthIndex, day);
  })();

  return (
    <Stack spacing="4" mt="2" mb="1">
      <Text>
        {props.label}
        {props.required && <Required />}
      </Text>
      <ReactDatePicker
        preventOpenOnFocus={true}
        className={"react-datepicker react-datepicker-wrapper"}
        renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => {
          return (
            <div>
              <button
                aria-label="Previous Month"
                className={
                  "react-datepicker__navigation react-datepicker__navigation--previous"
                }
                onClick={decreaseMonth}
              >
                <LeftArrowIcon className={"react-datepicker-icon-left"} />
              </button>
              <span className="react-datepicker__current-month">
                {moment.utc(date).format("MMMM YYYY")}
              </span>
              <button
                aria-label="Next Month"
                className={
                  "react-datepicker__navigation react-datepicker__navigation--next"
                }
                onClick={increaseMonth}
              >
                <RightArrowIcon className={"react-datepicker-icon-right"} />
              </button>
            </div>
          );
        }}
        selected={dateDefault}
        onChange={(date) => {
          if (!date) {
            props.onChange(props.field, "");
            return;
          }
          // Extract calendar components from the local date to preserve the
          // visually selected day, and emit a UTC date-only string.
          const d = date as Date;
          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, "0");
          const day = d.getDate().toString().padStart(2, "0");
          props.onChange(props.field, `${year}-${month}-${day}`);
        }}
        dateFormat="MM/dd/yyyy"
      />
      <Text color="red.500">{props.error}</Text>
    </Stack>
  );
};
